import React, {useContext} from 'react';
import { fetchVariableConfig } from '../helpers/fetchVariableConfig';
import { AppContext } from '../components/AppContext';

const LegendSelector = () => {

  const { config, setMapData, setMapKey } = useContext(AppContext)

  // { selectedValue, setSelectedValue, layer, setKey, setVariable, setData, legendConfig}
  const handleInputChange = (e) => {
    // setSelectedValue(e.target.value);
    fetchVariableConfig( e.target.value )
    .then( data => {        
        setMapData(data)
        setMapKey(e.target.value ) 
    })
  }

  if(config){
    const variables = config.variables
    return (
      <>
        <div className="legend-section">
          {/* <div className="legend-label">{ layer }</div> */}
          {/* <label htmlFor="variable-selector" className="label-variable">Variable:</label> */}
          <select
            id="variable-selector"
            onChange={(e) => handleInputChange(e)}
            className="variable-selector"
            // value={selectedValue}
          >
            <option value="" hidden>Seleccionar Variable</option>
            {Object.keys(variables).map((key) => (
              <option key={key} value={key}>{variables[key].label}</option>
            ))}
          </select>
          {/* <LegendContent geoserverUrl={geoserverUrl} layerName={layer} styleName={variable} ></LegendContent> */}
        </div>
      </>
    );
  }

}


export default LegendSelector;
